"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const xstate_1 = require("xstate");
const actions = __importStar(require("./actions"));
const services = __importStar(require("./services"));
const constants_1 = require("../common/constants");
const createCrmConnectorMachine = (context) => (0, xstate_1.createMachine)({
    id: 'Machine__Connector',
    initial: constants_1.CrmConnectorStates.initializing,
    context: Object.assign({ postMessageUrl: '', referrals: [], patient: undefined, maxReferralCount: 10, errors: [], validationErrors: {
            booking: undefined,
            referral: undefined
        }, retries: {
            requestPatient: 0,
            sendReferralData: 0,
            sendBookingData: 0
        }, maxRetries: {
            requestPatient: 3,
            sendReferralData: 0,
            sendBookingData: 0
        } }, context),
    states: {
        [constants_1.CrmConnectorStates.initializing]: {
            initial: constants_1.CrmConnectorStates.validatingPostMessageUrl,
            entry: ['captureEnvData'],
            states: {
                [constants_1.CrmConnectorStates.validatingPostMessageUrl]: {
                    invoke: {
                        src: 'validatePostMessage',
                        onDone: {
                            target: constants_1.CrmConnectorStates.sendingPatientRequest,
                            actions: ['updatePostMessageUrl', 'onPostMessageUrlValidated']
                        },
                        onError: {
                            target: constants_1.CrmConnectorStates.invalidPostMessageUrl,
                            actions: ['setError']
                        }
                    }
                },
                [constants_1.CrmConnectorStates.invalidPostMessageUrl]: {
                    always: `#${constants_1.CrmConnectorStates.initializationError}`
                },
                [constants_1.CrmConnectorStates.sendingPatientRequest]: {
                    invoke: {
                        src: 'requestPatient',
                        onDone: {
                            target: constants_1.CrmConnectorStates.requestPatientAwaitingResponse
                        },
                        onError: {
                            target: constants_1.CrmConnectorStates.requestPatientFailed,
                            actions: ['setError']
                        }
                    }
                },
                [constants_1.CrmConnectorStates.requestPatientAwaitingResponse]: {
                    after: {
                        REQUEST_PATIENT_DELAY: [
                            {
                                cond: (ctx) => ctx.maxRetries.requestPatient <= 0,
                                actions: [(0, xstate_1.send)(constants_1.CrmConnectorEvents.FAIL_NO_RETRY)]
                            },
                            {
                                cond: (ctx) => ctx.retries.requestPatient <
                                    ctx.maxRetries.requestPatient,
                                actions: [(0, xstate_1.send)(constants_1.CrmConnectorEvents.RETRY)]
                            },
                            {
                                actions: [(0, xstate_1.send)(constants_1.CrmConnectorEvents.FAIL_MAX_RETRIES)]
                            }
                        ]
                    },
                    on: {
                        [constants_1.CrmConnectorEvents.UNKNOWN_ORIGIN]: {
                            actions: ['captureEnvData']
                        },
                        [constants_1.CrmConnectorEvents.PATIENT_RECEIVED]: {
                            target: constants_1.CrmConnectorStates.completeInitializing,
                            actions: ['setPatientInContext', 'onPatientReceived']
                        },
                        [constants_1.CrmConnectorEvents.RETRY]: {
                            target: constants_1.CrmConnectorStates.sendingPatientRequest,
                            actions: ['incrementRetriesRequestPatient', 'onRetry']
                        },
                        [constants_1.CrmConnectorEvents.FAIL_MAX_RETRIES]: {
                            target: constants_1.CrmConnectorStates.noPatientDataReceived,
                            actions: ['setError', 'onFailMaxRetries']
                        },
                        [constants_1.CrmConnectorEvents.FAIL_NO_RETRY]: {
                            target: constants_1.CrmConnectorStates.noPatientDataReceived,
                            actions: ['setError', 'onFailNoRetry']
                        }
                    }
                },
                [constants_1.CrmConnectorStates.requestPatientFailed]: {
                    always: `#${constants_1.CrmConnectorStates.initializationError}`
                },
                [constants_1.CrmConnectorStates.noPatientDataReceived]: {
                    always: `#${constants_1.CrmConnectorStates.initializationError}`
                },
                [constants_1.CrmConnectorStates.completeInitializing]: {
                    type: 'final'
                }
            },
            onDone: {
                target: constants_1.CrmConnectorStates.initialized
            }
        },
        [constants_1.CrmConnectorStates.initialized]: {
            entry: ['onInitialization'],
            // parallel states
            type: 'parallel',
            states: {
                [constants_1.CrmConnectorStates.referral]: {
                    initial: constants_1.CrmConnectorStates.init,
                    entry: ['validatePatientForReferral'],
                    states: {
                        [constants_1.CrmConnectorStates.init]: {
                            always: [
                                {
                                    target: constants_1.CrmConnectorStates.invalidPatientData,
                                    cond: (ctx) => !!ctx.validationErrors.referral
                                },
                                {
                                    target: constants_1.CrmConnectorStates.ready
                                }
                            ]
                        },
                        [constants_1.CrmConnectorStates.invalidPatientData]: {},
                        // patient data is valid for referrals
                        [constants_1.CrmConnectorStates.ready]: {
                            always: [
                                {
                                    target: constants_1.CrmConnectorStates.someReferrals,
                                    cond: (ctx) => ctx.referrals.length > 0 &&
                                        ctx.referrals.length < ctx.maxReferralCount
                                },
                                {
                                    target: constants_1.CrmConnectorStates.maxReferrals,
                                    cond: (ctx) => ctx.referrals.length === ctx.maxReferralCount
                                },
                                { target: constants_1.CrmConnectorStates.noReferrals }
                            ]
                        },
                        [constants_1.CrmConnectorStates.noReferrals]: {
                            on: {
                                [constants_1.CrmConnectorEvents.ADD_REFERRAL]: {
                                    target: constants_1.CrmConnectorStates.ready,
                                    actions: ['addReferral', 'onAddReferral']
                                }
                            }
                        },
                        [constants_1.CrmConnectorStates.someReferrals]: {
                            on: {
                                [constants_1.CrmConnectorEvents.REMOVE_REFERRAL]: {
                                    target: constants_1.CrmConnectorStates.ready,
                                    actions: ['removeReferral', 'onRemoveReferral']
                                },
                                [constants_1.CrmConnectorEvents.ADD_REFERRAL]: {
                                    target: constants_1.CrmConnectorStates.ready,
                                    actions: ['addReferral', 'onAddReferral']
                                },
                                [constants_1.CrmConnectorEvents.SEND_REFERRAL_DATA]: {
                                    target: constants_1.CrmConnectorStates.sendingReferralData,
                                    actions: ['onSendReferralData']
                                }
                            }
                        },
                        [constants_1.CrmConnectorStates.maxReferrals]: {
                            on: {
                                [constants_1.CrmConnectorEvents.REMOVE_REFERRAL]: {
                                    target: constants_1.CrmConnectorStates.ready,
                                    actions: ['removeReferral', 'onRemoveReferral']
                                },
                                [constants_1.CrmConnectorEvents.SEND_REFERRAL_DATA]: {
                                    target: constants_1.CrmConnectorStates.sendingReferralData,
                                    actions: ['onSendReferralData']
                                }
                            }
                        },
                        [constants_1.CrmConnectorStates.sendingReferralData]: {
                            invoke: {
                                id: 'sendReferralData',
                                src: 'sendReferralData',
                                onDone: {
                                    target: constants_1.CrmConnectorStates.ready,
                                    actions: 'clearReferrals'
                                },
                                onError: {
                                    target: constants_1.CrmConnectorStates.sendingReferralDataError,
                                    actions: ['setError']
                                }
                            }
                        },
                        [constants_1.CrmConnectorStates.sendingReferralDataError]: {
                            initial: constants_1.CrmConnectorStates.displayError,
                            states: {
                                [constants_1.CrmConnectorStates.displayError]: {
                                    on: {
                                        [constants_1.CrmConnectorEvents.DISMISS_ERROR]: [
                                            {
                                                target: constants_1.CrmConnectorStates.noErrorToDisplay,
                                                cond: (ctx) => ctx.errors.length === 1,
                                                actions: ['dismissError']
                                            },
                                            { actions: ['dismissError'] }
                                        ]
                                    }
                                },
                                [constants_1.CrmConnectorStates.noErrorToDisplay]: {}
                            }
                        }
                    }
                },
                [constants_1.CrmConnectorStates.booking]: {
                    initial: constants_1.CrmConnectorStates.init,
                    entry: ['validatePatientForBooking'],
                    states: {
                        [constants_1.CrmConnectorStates.init]: {
                            always: [
                                {
                                    target: constants_1.CrmConnectorStates.invalidPatientData,
                                    cond: (ctx) => !!ctx.validationErrors.booking
                                },
                                {
                                    target: constants_1.CrmConnectorStates.ready
                                }
                            ]
                        },
                        // patient data is invalid for booking
                        [constants_1.CrmConnectorStates.invalidPatientData]: {},
                        // patient data is valid for booking
                        [constants_1.CrmConnectorStates.ready]: {
                            on: {
                                [constants_1.CrmConnectorEvents.SEND_BOOKING_DATA]: {
                                    target: constants_1.CrmConnectorStates.sendingBookingData,
                                    actions: ['onSendBookingData']
                                }
                            }
                        },
                        [constants_1.CrmConnectorStates.sendingBookingData]: {
                            invoke: {
                                id: 'sendBookingData',
                                src: 'sendBookingData',
                                onDone: {
                                    target: constants_1.CrmConnectorStates.ready
                                },
                                onError: {
                                    target: constants_1.CrmConnectorStates.sendingBookingDataError,
                                    actions: ['setError']
                                }
                            }
                        },
                        [constants_1.CrmConnectorStates.sendingBookingDataError]: {
                            initial: constants_1.CrmConnectorStates.displayError,
                            states: {
                                [constants_1.CrmConnectorStates.displayError]: {
                                    on: {
                                        [constants_1.CrmConnectorEvents.DISMISS_ERROR]: [
                                            {
                                                target: constants_1.CrmConnectorStates.noErrorToDisplay,
                                                cond: (ctx) => ctx.errors.length === 1,
                                                actions: ['dismissError']
                                            },
                                            {
                                                actions: ['dismissError']
                                            }
                                        ]
                                    }
                                },
                                [constants_1.CrmConnectorStates.noErrorToDisplay]: {}
                            }
                        }
                    }
                }
            }
        },
        [constants_1.CrmConnectorStates.initializationError]: {
            id: constants_1.CrmConnectorStates.initializationError,
            initial: constants_1.CrmConnectorStates.displayError,
            entry: ['onInitializationError'],
            states: {
                [constants_1.CrmConnectorStates.displayError]: {
                    on: {
                        [constants_1.CrmConnectorEvents.DISMISS_ERROR]: [
                            {
                                target: constants_1.CrmConnectorStates.noErrorToDisplay,
                                cond: (ctx) => ctx.errors.length === 1,
                                actions: ['dismissError']
                            },
                            {
                                actions: ['dismissError']
                            }
                        ]
                    }
                },
                [constants_1.CrmConnectorStates.noErrorToDisplay]: {}
            }
        }
    }
}, {
    actions,
    services,
    delays: {
        REQUEST_PATIENT_DELAY: 2000
    }
});
exports.default = createCrmConnectorMachine;
//# sourceMappingURL=machine.js.map